// extracted by mini-css-extract-plugin
export default {"container":"QO-z","title":"RO-z","link":"SO-z"};